import { useState } from "react";

import Table from "../../../tables/components/Table";

import useDistributionPresetDropdownOptions from "../../hooks/useDistributionPresetDropdownOptions";
import useDistributionPresetsTableColumns from "../../hooks/useDistributionPresetsTableColumns";

import DistributionPresetForm from "../DistributionPresetForm/DistributionPresetForm";

export default function DistributionPresetsTable({ publisher }) {
	const [selectedPreset, setSelectedPreset] = useState(null);

	const data = Object.values(publisher?.distribution?.presets || []).sort((a, b) => {
		return (
			a.channel.name.localeCompare(b.channel.name) ||
			(a.languages?.[0] ?? "").localeCompare(b.languages?.[0] ?? "") ||
			a.articleType.localeCompare(b.articleType)
		);
	});

	const columns = useDistributionPresetsTableColumns({ publisher });

	const getDropdownMenuOptions = useDistributionPresetDropdownOptions({ publisher });

	return (
		<>
			<Table
				data={data}
				columns={columns}
				onClick={(preset) => setSelectedPreset(preset)}
				getDropdownMenuOptions={getDropdownMenuOptions}
			/>

			{selectedPreset && (
				<DistributionPresetForm
					publisher={publisher}
					preset={selectedPreset}
					onClose={() => setSelectedPreset(null)}
				/>
			)}
		</>
	);
}
